import {IBillOption, IInvoiceList, IToBillDetails} from '../core/_model'

export interface IVoucherFormValuesType {
  invoice: string
  invoiceId: number | null
  amount: number
}

export interface IVoucherFilterType {
  sdate: string
  edate: string
  username: string
  userId: number | null
  voucher: string
  voucherId: number | null
}

export interface IVoucherList {
  id: number
  voucher_no: string
  amount: number
  due: number
  created_at: number
  invoice_id: number
  invoice_no: string
  user_full_name: string
}

export interface InvoiceInfo extends IInvoiceList {
  due: number
  invoice_status: string
}

export interface IVoucherInfo {
  id: number
  voucher_no: string
  amount: number
  due: number
  invoice_no: string
  user_full_name: string
  created_at: string
}

export interface IVoucherDetailsResponse {
  invoiceInfo: InvoiceInfo
  voucherInfo: IVoucherInfo
  fromBillDetails: IBillOption[]
  toBillDetails: IToBillDetails
}

export interface InvoiceHeaderFooter {
  invoice_header: {
    company_name: string
    address: string
    bin_no: string
    tin_no: string
  }
  invoice_footer: {
    contact: string
    email: string
    section_one: string
    section_two: {
      account_name: string
      account_number: string
      bank_name: string
      bank_address: string
      branch_name: string
      routing_no: string
      swift_id: string
    }
  }
}

export const initVoucherFormValues: IVoucherFormValuesType = {
  invoice: '',
  invoiceId: null,
  amount: 0,
}

export const initVoucherFilterValues: IVoucherFilterType = {
  sdate: '',
  edate: '',
  username: '',
  userId: null,
  voucher: '',
  voucherId: null,
}
